/** Mock preview for /activities — no backend required. */
export function isActivitiesMockMode(search: { readonly mock?: string }): boolean {
  if (search.mock === "0") return false;
  if (search.mock === "1") return true;
  // Local design review: mock on by default in dev unless explicitly disabled.
  if (import.meta.env.DEV) return true;
  if (typeof window !== "undefined") {
    try {
      return window.localStorage.getItem("morrow-activities-mock") === "1";
    } catch {
      return false;
    }
  }
  return false;
}

export function enableActivitiesMockPersisted(): void {
  try {
    window.localStorage.setItem("morrow-activities-mock", "1");
  } catch {
    /* ignore */
  }
}
